import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IBulkScanRejection } from '@core/interfaces';


/**
 * Generic report displayed after a bulk operation: how many items were processed
 * and the list of the rejected ones with the reason.
 */
@Component({
  selector: 'app-bulk-scan-result-modal',
  templateUrl: './bulk-scan-result-modal.component.html',
})
export class BulkScanResultModalComponent {

  @Input() public title: string = 'Résultat de l\'ajout par lot';
  @Input() public acceptedCount: number = 0;
  @Input() public rejected: IBulkScanRejection[] = [];
  @Input() public valueLabel: string = 'Numéro de série';

  constructor(public modal: NgbActiveModal) {}
}
